import { useState } from "react"
import EstablishmentCalendarOverview from "./EstablishmentCalendarOverview"
import EstablishmentRpsOverview from "./EstablishmentRpsOverview"

/** La seconde ligne reste mesurable, meme lorsque RPS occupe toute la colonne. */
export default function EstablishmentPreventionOverview() {
  const [canFitPrevention, setCanFitPrevention] = useState(true)

  return (
    <div
      className="grid min-h-0 min-w-0 flex-1 gap-[20px]"
      style={{ gridTemplateRows: "220px minmax(0, 1fr)", gridTemplateColumns: "minmax(0, 1fr)" }}>
      <div className="flex min-h-0 min-w-0" style={{ gridColumn: 1, gridRow: canFitPrevention ? "1" : "1 / 3" }}>
        <EstablishmentRpsOverview fillHeight />
      </div>
      <div
        className="flex min-h-0 min-w-0"
        style={{ gridColumn: 1, gridRow: 2, visibility: canFitPrevention ? "visible" : "hidden" }}>
        <EstablishmentCalendarOverview onCapacityChange={setCanFitPrevention} />
      </div>
    </div>
  )
}
